import axios from 'axios';
import cacheIndefinitely from './cacheIndefinitely';

const cmsApiUrl = 'https://api-us.storyblok.com/v2/cdn/stories';
const cmsApiKey: string = process.env.STORYBLOK_API_KEY;

export const buildUrl = (params: object): string => {
  return Object.entries(params).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join('&')
}

export const getCachedContent = async (params: object, slug = null) => {
  return await cacheIndefinitely(`storyblok_${JSON.stringify(params)}_${slug}`, async() => {
    return await getContent(params, slug);
  });
}

export const getContent = async (params: object, slug = null) => {
  const url = !slug ? cmsApiUrl : cmsApiUrl + '/' + slug;
  const urlParams = buildUrl({ token: cmsApiKey, ...params });
  const response = await axios.get(url + '?' + urlParams);
  return response?.data;
}

const storyblockHelpers = {
  buildUrl,
  getCachedContent,
  getContent,
};

export default storyblockHelpers;
